export const RESULTS_KEY = 'results';
